import { useDatasetContext } from '@vivli/features/datasets/infrastructure/context';
import { DatasetTabsComponent } from './dataset-tabs.component';

// Renders the dataset tabs for the requested-study URL flow. The admin
// "View Data Package" tab is hidden when the requested study has no
// IPD data package id, since DatasetViewComponent would otherwise call
// DataPackagesController with a null id.
export const RequestedStudyDatasetTabsComponent = () => {
    const { requestedStudyDownloadableIpdPackageId } = useDatasetContext();
    const hideAdminViewTab = !requestedStudyDownloadableIpdPackageId;
    return <DatasetTabsComponent hideAdminViewTab={hideAdminViewTab} />;
};
